module.exports = __webpack_public_path__ + "img/48.815ba1e3.jpg";